import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';

export default class MobileNavigation extends Component {
  static propTypes = {
    childRoutes: PropTypes.array.isRequired,
    routing: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.toggleNav = this.toggleNav.bind(this);
    this.activeRoute = this.getCurrentRoute(props);
    this.state = {
      isNavHidden: true,
    };
  }

  componentWillMount() {
    this.setState({
      activeItemTitle: this.activeRoute
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      activeItemTitle: this.getCurrentRoute(nextProps),
      isNavHidden: true
    });
  }

  getCurrentRoute(props) {
    const routeMatch = props.childRoutes.filter((route) => {
      if (route.path === props.routing.location.pathname) {
        return route.name;
      }
    });
    if (routeMatch.length) return routeMatch[0].name;
    return null;
  }

  selectNavItem(item) {
    this.setState({
      activeItemTitle: item.name,
      isNavHidden: !this.state.isNavHidden
    });
  }

  toggleNav() {
    this.setState({
      isNavHidden: !this.state.isNavHidden
    });
  }

  render() {
    const navHiddenClass = classNames({
      mobileNavigation__link__list__container__hidden: this.state.isNavHidden
    });
    return (
      <div className="mobileNavigation__container">
        <div className="mobileNavigation__active__item" onClick={this.toggleNav}>
          <span className="mobileNavigation__active__item__title">
            {this.state.activeItemTitle}
          </span>
          {(() => {
            return this.state.isNavHidden ? <i className="fa fa-chevron-down" /> : <i className="fa fa-chevron-up" />;
          })()}
        </div>
        <div className={navHiddenClass}>
          <ul className="mobileNavigation__link__list">
          {this.props.childRoutes.map((route) => {
            return (
              <li onClick={this.selectNavItem.bind(this, route)} key={route.name}>
                <NavLink
                  className="mobileNavigation__link__list_link"
                  activeClassName="mobileNavigation__link__list_active"
                  to={route.path}>
                  {route.name}
                </NavLink>
              </li>
            );
          })}
          </ul>
        </div>
      </div>
    );
  }
}
